import { render, staticRenderFns } from "./Class2List.vue?vue&type=template&id=06bccc42&scoped=true"
import script from "./Class2List.vue?vue&type=script&lang=js"
export * from "./Class2List.vue?vue&type=script&lang=js"
import style0 from "./Class2List.vue?vue&type=style&index=0&id=06bccc42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bccc42",
  null
  
)

export default component.exports